const de_DE = {
    homepage_title: 'CalendarTask mobil per QR-Code herunterladen',
    homepage_slogn: 'CalendarTask mobile Version',
    homepage_ios_download: 'App Store in Prüfung...',
    homepage_download: 'Jetzt herunterladen',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'CalendarTask mobil per QR-Code herunterladen',
    phonedownload_slogan: 'Mit PC & Tablet synchronisieren, Notizen überall',
    phonedownload_send_vip: 'App installieren und VIP-Mitgliedschaft erhalten',
    phonedownload_screenshot: 'Screenshot',
    phodedownload_macos: 'CalendarTask macOS-Version',
    phodedownload_windows: 'CalendarTask Windows-Version',
    phodedownload_otherbutton: 'Jetzt ansehen',
    phodedownload_about: 'Kontakt',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Keine Werbung',
    feature_easy: 'Monatsansicht, einfach zu bedienen',
    feature_reminder: 'Benutzerdefinierte Erinnerung',
    feature_countdown: 'Countdown-Gedenktag',

    vip_task_succ: 'Erfolg. Mobile App laden, VIP aktivieren',
    vip_task_error: 'Empfang fehlgeschlagen',

    group_slogn: 'CalendarTask Team-Einladung',

    tt_title: 'CalendarTask',
    tt_share_1: 'Mit Ihnen geteilt',
    tt_share_2: 'Stundenplan',
    tt_share_show_1: 'Scannen Sie den QR-Code mit der "CalendarTask"-App, dann wird',
    tt_share_show_2: 's Stundenplan auf PC und Handy angezeigt',
    tt_share_scan_1: 'Mit',
    tt_share_scan_2: '"CalendarTask"-App scannen',
    tt_share_succ: 'Synchronisierung erfolgreich',

    v2_copyright: 'Kontakt service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Alle Rechte vorbehalten.',
    v2_download_appstore: 'Im App Store laden',
    v2_download_googleplay: 'Bei Google Play laden',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Im App Store oder Google Play <span class="name">CalendarTask</span> suchen zum Laden',
    v2_download_ios: 'iOS herunterladen',
    v2_download_android: 'Android herunterladen',
    v2_download_harmonyos: 'HarmonyOS herunterladen',
    v2_sync_status: 'Synchronisierung abgeschlossen! 1 hochgeladen, 0 heruntergeladen',
    v2_feature_title: 'Multi-Geräte-Datensynchronisation',
    v2_feature_description: 'Sync zwischen Handy, Tablet und PC'
};
export default de_DE;
